var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrap"},[_c('div',{staticClass:"lesson-info"},[_c('span',[_vm._v("第"+_vm._s(_vm.lessonNum)+"讲")]),_c('a-divider',{attrs:{"type":"vertical"}}),_c('span',[_vm._v(_vm._s(_vm.lessonName))])],1),_c('div',{staticClass:"middle"},[_vm._t("end-tip"),_vm._t("end-btn")],2),_c('div',{staticClass:"right"},[_vm._t("undo-btn")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }